import { Reducer } from '../../../../@types';
import { FuelTransactionsTypes } from '../../../../@types/enums';
import { initialState, FuelTransactionsState } from './initialState';

// @ts-ignore
export const fuelTransactionsReducer: Reducer<FuelTransactionsState> = (
  state = initialState,
  action
) => {
  switch (action.type as any) {
    case FuelTransactionsTypes.FUEL_TRANSACTIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FuelTransactionsTypes.FUEL_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        entities: action.payload,
        loading: false,
      };
    case FuelTransactionsTypes.FUEL_TRANSACTIONS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case FuelTransactionsTypes.SET_DISPLAY_FUEL_TRANSACTIONS:
      return {
        ...state,
        display: action.payload,
      };
    case FuelTransactionsTypes.SET_TOTAL_FUEL_TRANSACTIONS:
      return {
        ...state,
        total: action.payload,
      };
    case FuelTransactionsTypes.SELECT_FUEL_TRANSACTION:
      return {
        ...state,
        selected: action.payload,
      };
    case FuelTransactionsTypes.FUEL_TRANSACTION_REQUEST:
      return {
        ...state,
        fuelTransactionLoading: true,
      };
    case FuelTransactionsTypes.FUEL_TRANSACTION_SUCCESS:
      return {
        ...state,
        entities: state.entities
          ? state.entities.map((entity) =>
              entity?.id === action.payload?.id
                ? { ...entity, ...action.payload }
                : entity
            )
          : null,
        display: state.display
          ? state.display.map((entity) =>
              entity?.id === action.payload?.id
                ? { ...entity, ...action.payload }
                : entity
            )
          : null,
        selected: { ...state?.selected, ...action?.payload },
        fuelTransactionLoading: false,
      };
    case FuelTransactionsTypes.FUEL_TRANSACTION_FAILURE:
      return {
        ...state,
        error: action.error,
        fuelTransactionLoading: false,
      };
    default:
      return state;
  }
};
